import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../services/api';
// Removed opportunities reducer - now using Context for high-frequency data
import settingsReducer from '../features/settings/settingsSlice';
import networkStatusReducer from '../features/networkStatus/networkStatusSlice';
import snapshotsReducer from '../features/snapshots/snapshotsSlice';

export const store = configureStore({
  reducer: {
    // Add reducers here as features are developed
    [api.reducerPath]: api.reducer,
    // opportunities: removed - now using Context for high-frequency trading data
    settings: settingsReducer,
    networkStatus: networkStatusReducer,
    snapshots: snapshotsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Optimize for large network status data
      serializableCheck: {
        // Reduce the warning threshold for better performance with large data
        warnAfter: 100,
        // Ignore specific large data paths that are known to be serializable
        ignoredActionPaths: [
          'payload.cryptos', 
          'payload.0.cryptos',
          // Also ignore individual network status updates
          'payload', 
          'meta.arg'
        ],
        ignoredPaths: ['networkStatus.data'],
      },
      immutableCheck: {
        // Also optimize immutability checks for large data
        warnAfter: 100,
        ignoredPaths: ['networkStatus.data'],
      },
    }).concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks for use throughout the app
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;